import { User } from "../../models/user"; 

export namespace BlockUI
{
    export class LoggedIn
    {
        static readonly type ="[UI Login Action] Successful Login"
        constructor(public payload: { user: User }) {}
    }

    export class BlockUI
    {
        static readonly type="[General] Block UI";
    }

    export class UnBlockUI
    {
        static readonly type="[General] Unblock UI";
    }
}
